export enum LifePageIds {
    pollen = 'life/pollen',
    coldFlu = 'life/coldflu',
    outdoorSports = 'life/outdoor-sports',
    snowSki = 'life/snow-ski',
    travel = 'life/travel',
    snowSkiDetail = 'life/snow-ski-detail'
}

export enum LifePageRoutePaths {
    pollen = '/life/pollen/',
    coldFlu = '/life/cold-flu/',
    outdoorSports = '/life/outdoor-sports/',
    snowSki = '/life/snow-ski/',
    travel = '/life/travel/'
}